<template>
  <el-dialog :title="$t('app.logisticsDetailsTitle')" custom-class="MyDialog" :visible.sync="isShowDialog" width="700px" @close="closeDialog">
      <el-form ref="form" :model="expressObjForm"  label-width="100px">
        <el-form-item :label="$t('app.label')">
          <el-input v-model="expressObjForm.companyName" :disabled="true" :style="{
            width: '60%',
            marginRight: '20px',
          }" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app.label')">
          <el-input v-model="expressObjForm.expressNo" :disabled="true" :style="{
            width: '60%',
            marginRight: '20px',
          }" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app.label')">
          <el-input v-model="expressObjForm.expressPhone" :disabled="true" :style="{
            width: '60%',
            marginRight: '20px',
          }" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div class="box" :style="{
        height: logisticsData.length !== 0 ? 'auto' : '40px',
        maxHeight: '380px',
        overflow: logisticsData.length !== 0 ? 'auto' : 'hidden',
        padding: '24px',
        textAlign: logisticsData.length !== 0 ? 'auto' : 'center',
      }">
        <!-- <div :style="{
          color: 'red'
        }">
          {{ logisticsMessage.length > 0 ? '*' + logisticsMessage : '' }}
        </div> -->
        <div style="height: 500px;" class="timeLine">
          <el-timeline>
            <el-timeline-item placement="top" v-for="(item, index) in logisticsData" :key="index"
              :timestamp="item.ftime" :color="index === 0 ? '#e84118' : ''" :class="index === 0 ? 'timeLineRed' : ''">
              <div style="display:flex">
                <div v-if="index == 0"
                  style="color: white; background: red; width: 40px; text-align: center; font-weight: 900;height: 20px;position: absolute;">{{ $t('app.latest') }}</div>
                <div :style="{ color: index == 0 ? 'red' : '', marginLeft: '40px',textAlign: 'left' }">
                  {{ item.context }}
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isShowDialog: false,
    }
  },
  props: {
    showLogisticsDialog: {
      type: Boolean,
      default: false,
    },
    expressObjForm: {
      type: Object,
      default: function() {
        return {};
      }
    },
    logisticsData: {
      type: Array,
      default: [],
    }
  },
  watch: {
    showLogisticsDialog: {
      handler(newValue, oldValue) {
        this.isShowDialog = newValue;
      },
      immediate: true
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeLogisticsDialog");
    },
  },
}
</script>

<style>

</style>